import { useDashboardsViewOnlyFeatureGate } from './use-dashboards-view-only-feature-gate';
import { useReportsViewOnlyFeatureGate } from './use-reports-view-only-feature-gate';

export const useIsInsightsPageFeatureEnabled = () => {
  const { isFeatureEnabled: isDashboardsEnabled } = useDashboardsViewOnlyFeatureGate();
  const { isFeatureEnabled: isReportsEnabled } = useReportsViewOnlyFeatureGate();

  return isDashboardsEnabled || isReportsEnabled;
};
